import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@auth0/auth0-angular';
import { SecureComponent } from './secure/secure.component';
import { CallbackComponent } from './core/callback/callback.component';
import { TagsComponent } from './pages/tags/tags.component';
import { ClientiComponent } from './pages/clienti/clienti.component';
import { CommesseComponent } from './pages/commesse/commesse.component';
import { RuoliReferenzaComponent } from './pages/ruoli-referenza/ruoli-referenza.component';

const routes: Routes = [
  {
    path: 'callback',
    component: CallbackComponent,
  },
  {
    path: 'secure',
    component: SecureComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'utenti',
    component: SecureComponent, // Placeholder - sostituire con componente dedicato
    canActivate: [AuthGuard],
  },
  {
    path: 'clienti',
    component: ClientiComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'commesse',
    component: CommesseComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'tags',
    component: TagsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'ruoli-referenza',
    component: RuoliReferenzaComponent,
    canActivate: [AuthGuard],
  },
  // Qualsiasi altro path torna alla home pubblica
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}

